require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/fn/object/set-prototype-of.js
// module id = 957
// module chunks = 48 49 50